<script>
import isEmpty from 'lodash.isempty'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import { mapGetters } from 'vuex'

export default {
    name: 'CanteenAlert',
    components: { ButtonLoader },
    props: {
        restaurant: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        ...mapGetters({
            activeCanteen: 'active/canteen',
            smDevice: 'smDevice',
            orderAddress: 'order/address',
        }),
        canteenIsSelected() {
            return !isEmpty(this.activeCanteen)
        },
        time() {
            return this.activeCanteen?.delivery_time
        },
        address() {
            return this.activeCanteen.isResidential
                ? this.activeCanteen.address.user_address
                    ? this.$addresses.findItem(this.getId(this.activeCanteen.user_address))
                    : this.activeCanteen.address
                : this.$addresses.findItem(this.getId(this.activeCanteen.address))
        },
    },
    async mounted() {
        if (!this.$addresses.total && this.$user.isLoggedIn) {
            this.$addresses.fetch()
        }
    },
    methods: {
        async resetCc() {
            try {
                this.loading = true
                await this.$store.dispatch('order/setAddress', this.orderAddress)
                await this.$store.dispatch('active/resetCanteen')
                await this.$user.getExpenseRules()
                await this.restaurant.fetchRestaurant(this.restaurant.slug)
                await this.$router.replace({
                    name: 'restaurant',
                    params: {
                        slug: this.$route.params.slug,
                        menu: this.$route.params.menu,
                    },
                    query: this.$route.query,
                })
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<template lang="pug">
transition(name="alert")
    .canteen-alert.alert-wrapper(v-if="canteenIsSelected")
        .mt-5.mt-lg-0
            .alert.alert-info.flex-center.flex-wrap
                .icon-mix.mr-2
                    icon(icon="fa-solid fa-cloud"  size="lg")
                    icon.text-info(icon="fa-solid fa-burger" size="sm")
                span.line-1 {{$t('canteen.alert')}}

                span.line-1.ml-2.text-center.text-lg-left.mt-3.mt-lg-0 [{{ time | toDeliveryTime}}
                    template(v-if="address")
                        | &nbsp;{{$t('base.to')}}&nbsp;
                        template(v-if="address.name") {{address.name}}]
                        template(v-else-if="address.full_address") {{address.full_address}}]
                button-loader.btn.btn-xs.btn-info-light.ml-lg-6.mt-4.mt-lg-0(@click="resetCc" :disabled="loading" :class="{'btn-block': smDevice}" :loading="loading" inline) {{$t('base.exit')}}
</template>
